import * as React from 'react'
import { SVGProps } from 'react'
const CoverPlaceholder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={450}
    height={450}
    viewBox="0 0 450 450"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_18079_41035)">
      <path
        d="M0 20C0 8.9543 8.95431 0 20 0H430C441.046 0 450 8.95431 450 20V430C450 441.046 441.046 450 430 450H20C8.9543 450 0 441.046 0 430V20Z"
        fill="white"
      />
      <g clipPath="url(#clip1_18079_41035)">
        <g clipPath="url(#clip2_18079_41035)">
          <rect
            x={-3.13037}
            y={-0.782593}
            width={456.604}
            height={450.92}
            rx={3.19199}
            fill="white"
          />
          <g clipPath="url(#clip3_18079_41035)">
            <path
              d="M111.229 336.053L224.825 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 336.053H224.825"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.5835 449.593H110.805"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.229 449.594L111.229 222.727"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2168 222.727L54.2168 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7246 336.053V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M168.027 364.493C168.027 348.787 155.313 336.054 139.628 336.054C123.944 336.054 111.229 348.787 111.229 364.493C111.229 380.2 123.944 392.932 139.628 392.932C155.313 392.932 168.027 380.2 168.027 364.493Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M168.144 364.466H221.017"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.229 364.493H-2.58252"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.232 336.053L82.7246 364.492"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 336.053L54.2168 364.492"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9238 449.594L25.9238 222.727"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2148 336.053L25.9238 364.492"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 378.713C82.7238 370.86 76.3423 364.493 68.4703 364.493C60.5983 364.493 54.2168 370.86 54.2168 378.713C54.2168 386.566 60.5983 392.932 68.4703 392.932C76.3423 392.932 82.7238 386.566 82.7238 378.713Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7218 378.712H25.9238"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4717 364.492V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 364.495C-2.58252 352.992 4.33525 342.624 14.9478 338.22C25.5603 333.817 37.7739 336.251 45.8969 344.386C54.0198 352.52 56.4474 364.751 52.0537 375.378C47.6565 386.005 37.3022 392.932 25.8151 392.932"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 279.39C-2.58252 294.418 3.41321 308.828 14.0834 319.456C24.7536 330.083 39.2289 336.053 54.3217 336.053C69.4145 336.053 83.8863 330.083 94.56 319.459C105.234 308.835 111.229 294.422 111.229 279.394"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 336.053C-2.58252 366.164 9.39792 395.043 30.7187 416.337C52.0429 437.631 80.9635 449.594 111.121 449.594C141.276 449.594 170.196 437.631 191.521 416.341C212.845 395.047 224.825 366.168 224.825 336.053"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 222.729L54.2154 279.392"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9238 251.167L54.2148 222.728"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4689 378.712L-2.58252 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9244 357.383C25.9244 353.456 22.7336 350.273 18.7976 350.273C14.8616 350.273 11.6709 353.456 11.6709 357.383C11.6709 361.309 14.8616 364.492 18.7976 364.492C22.7336 364.492 25.9244 361.309 25.9244 357.383Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.7993 364.492L18.7993 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.23 371.602C111.23 367.675 108.039 364.492 104.103 364.492C100.167 364.492 96.9766 367.675 96.9766 371.602C96.9766 375.529 100.167 378.712 104.103 378.712C108.039 378.712 111.23 375.529 111.23 371.602Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4717 336.053V222.727"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2154 251.06C54.2154 235.413 41.5008 222.729 25.8165 222.729C10.1321 222.729 -2.58252 235.413 -2.58252 251.06C-2.58252 266.707 10.1321 279.392 25.8165 279.392C41.5008 279.392 54.2154 266.707 54.2154 251.06Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 265.279C82.7238 257.485 76.3423 251.167 68.4703 251.167C60.5983 251.167 54.2168 257.485 54.2168 265.279C54.2168 273.072 60.5983 279.391 68.4703 279.391C76.3423 279.391 82.7238 273.072 82.7238 265.279Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.232 265.279C111.232 257.485 104.85 251.167 96.9781 251.167C89.1061 251.167 82.7246 257.485 82.7246 265.279C82.7246 273.072 89.1061 279.391 96.9781 279.391C104.85 279.391 111.232 273.072 111.232 265.279Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M96.9786 265.28C96.9786 257.486 90.5971 251.168 82.7252 251.168C74.8532 251.168 68.4717 257.486 68.4717 265.28C68.4717 273.074 74.8532 279.392 82.7252 279.392C90.5971 279.392 96.9786 273.074 96.9786 265.28Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4703 300.721C68.4703 296.794 65.2795 293.611 61.3436 293.611C57.4076 293.611 54.2168 296.794 54.2168 300.721C54.2168 304.647 57.4076 307.831 61.3436 307.831C65.2795 307.831 68.4703 304.647 68.4703 300.721Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2154 300.72H-2.58252"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip4_18079_41035)">
            <path
              d="M111.229 113.301L224.825 -0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 113.301L224.825 113.301"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.229 -0.240234L111.229 226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2168 226.627L54.2168 -0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7246 113.301V-0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M168.027 84.8606C168.027 100.567 155.313 113.3 139.628 113.3C123.944 113.3 111.229 100.567 111.229 84.8606C111.229 69.1541 123.944 56.4215 139.628 56.4215C155.313 56.4215 168.027 69.1541 168.027 84.8606Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M168.144 84.8885H221.017"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.229 84.8629H-2.58252"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.232 113.302L82.7246 84.8629"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 113.302L54.2168 84.8629"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9238 -0.240234L25.9238 226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2148 113.302L25.9238 84.8629"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 70.6411C82.7238 78.4944 76.3423 84.8607 68.4703 84.8607C60.5983 84.8607 54.2168 78.4944 54.2168 70.6411C54.2168 62.7878 60.5983 56.4215 68.4703 56.4215C76.3423 56.4215 82.7238 62.7878 82.7238 70.6411Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7218 70.6422H25.9238"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4717 84.8618V-0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 84.8591C-2.58252 96.3622 4.33525 106.731 14.9478 111.134C25.5603 115.537 37.7739 113.103 45.8969 104.969C54.0198 96.8346 56.4474 84.6039 52.0537 73.9767C47.6565 63.3494 37.3022 56.4221 25.8151 56.4221"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 169.964C-2.58252 154.936 3.41321 140.527 14.0834 129.899C24.7536 119.271 39.2289 113.301 54.3217 113.301C69.4145 113.301 83.8863 119.271 94.56 129.896C105.234 140.52 111.229 154.933 111.229 169.961"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 113.301C-2.58252 83.1897 9.39792 54.3104 30.7187 33.0167C52.0429 11.723 80.9635 -0.240234 111.121 -0.240234C141.276 -0.240234 170.196 11.7231 191.521 33.0134C212.845 54.3071 224.825 83.1863 224.825 113.301"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M-2.58252 226.627L54.2154 169.964"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9238 198.188L54.2148 226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4689 70.6423L-2.58252 -0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M25.9244 91.9728C25.9244 95.8994 22.7336 99.0825 18.7976 99.0825C14.8616 99.0825 11.6709 95.8994 11.6709 91.9728C11.6709 88.0461 14.8616 84.8629 18.7976 84.8629C22.7336 84.8629 25.9244 88.0461 25.9244 91.9728Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.7993 84.8618L18.7993 -0.240234"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.23 77.7521C111.23 81.6787 108.039 84.8618 104.103 84.8618C100.167 84.8618 96.9766 81.6787 96.9766 77.7521C96.9766 73.8254 100.167 70.6422 104.103 70.6422C108.039 70.6422 111.23 73.8254 111.23 77.7521Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4717 113.301V226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2154 198.295C54.2154 213.942 41.5008 226.627 25.8165 226.627C10.1321 226.627 -2.58252 213.942 -2.58252 198.295C-2.58252 182.648 10.1321 169.964 25.8165 169.964C41.5008 169.964 54.2154 182.648 54.2154 198.295Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M82.7238 184.076C82.7238 191.87 76.3423 198.188 68.4703 198.188C60.5983 198.188 54.2168 191.87 54.2168 184.076C54.2168 176.282 60.5983 169.964 68.4703 169.964C76.3423 169.964 82.7238 176.282 82.7238 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M111.232 184.076C111.232 191.87 104.85 198.188 96.9781 198.188C89.1061 198.188 82.7246 191.87 82.7246 184.076C82.7246 176.282 89.1061 169.964 96.9781 169.964C104.85 169.964 111.232 176.282 111.232 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M96.9786 184.076C96.9786 191.87 90.5971 198.188 82.7252 198.188C74.8532 198.188 68.4717 191.87 68.4717 184.076C68.4717 176.282 74.8532 169.964 82.7252 169.964C90.5971 169.964 96.9786 176.282 96.9786 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M68.4703 148.635C68.4703 152.561 65.2795 155.744 61.3436 155.744C57.4076 155.744 54.2168 152.561 54.2168 148.635C54.2168 144.708 57.4076 141.525 61.3436 141.525C65.2795 141.525 68.4703 144.708 68.4703 148.635Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M54.2154 148.635H-2.58252"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip5_18079_41035)">
            <path
              d="M339.113 336.053L225.517 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 336.053H225.519"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.928 449.593H339.539"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 449.594V222.727"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.126 222.727V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.62 336.053V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M282.315 364.493C282.315 348.787 295.03 336.054 310.714 336.054C326.399 336.054 339.113 348.787 339.113 364.493C339.113 380.2 326.399 392.933 310.714 392.933C295.03 392.933 282.315 380.2 282.315 364.493Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M282.199 364.466H229.326"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.115 364.492H452.927"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 336.054L367.62 364.493"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 336.053L396.126 364.492"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.419 449.594V222.727"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.128 336.054L424.419 364.493"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 378.713C367.619 370.86 374.001 364.493 381.872 364.493C389.744 364.493 396.126 370.86 396.126 378.713C396.126 386.566 389.744 392.933 381.872 392.933C374.001 392.933 367.619 386.566 367.619 378.713Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.621 378.712H424.419"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.872 364.492V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 364.496C452.927 352.992 446.009 342.624 435.396 338.221C424.784 333.817 412.57 336.252 404.447 344.386C396.324 352.52 393.897 364.751 398.291 375.378C402.688 386.005 413.042 392.933 424.529 392.933"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 279.39C452.927 294.418 446.931 308.828 436.261 319.456C425.591 330.084 411.115 336.053 396.023 336.053C380.93 336.053 366.458 330.083 355.784 319.459C345.111 308.835 339.115 294.422 339.115 279.394"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 336.053C452.927 366.164 440.946 395.044 419.626 416.337C398.301 437.631 369.381 449.594 339.223 449.594C309.068 449.594 280.148 437.631 258.824 416.341C237.499 395.047 225.519 366.168 225.519 336.053"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 222.729L396.129 279.392"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.418 251.167L396.127 222.728"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.875 378.712L452.927 449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.418 357.383C424.418 353.456 427.609 350.273 431.545 350.273C435.481 350.273 438.672 353.456 438.672 357.383C438.672 361.309 435.481 364.492 431.545 364.492C427.609 364.492 424.418 361.309 424.418 357.383Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M431.543 364.492V449.594"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 371.602C339.113 367.675 342.303 364.492 346.239 364.492C350.175 364.492 353.366 367.675 353.366 371.602C353.366 375.529 350.175 378.712 346.239 378.712C342.303 378.712 339.113 375.529 339.113 371.602Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.871 336.053V222.728"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.129 251.061C396.129 235.413 408.843 222.729 424.528 222.729C440.212 222.729 452.927 235.413 452.927 251.061C452.927 266.708 440.212 279.392 424.528 279.392C408.843 279.392 396.129 266.708 396.129 251.061Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 265.279C367.619 257.485 374.001 251.167 381.872 251.167C389.744 251.167 396.126 257.485 396.126 265.279C396.126 273.072 389.744 279.391 381.872 279.391C374.001 279.391 367.619 273.072 367.619 265.279Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 265.279C339.113 257.485 345.494 251.167 353.366 251.167C361.238 251.167 367.62 257.485 367.62 265.279C367.62 273.072 361.238 279.391 353.366 279.391C345.494 279.391 339.113 273.072 339.113 265.279Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M353.365 265.28C353.365 257.486 359.746 251.168 367.618 251.168C375.49 251.168 381.872 257.486 381.872 265.28C381.872 273.074 375.49 279.392 367.618 279.392C359.746 279.392 353.365 273.074 353.365 265.28Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.872 300.721C381.872 296.794 385.063 293.611 388.999 293.611C392.935 293.611 396.126 296.794 396.126 300.721C396.126 304.648 392.935 307.831 388.999 307.831C385.063 307.831 381.872 304.648 381.872 300.721Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.129 300.72H452.927"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip6_18079_41035)">
            <path
              d="M339.113 113.301L225.517 -0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 113.301L225.519 113.301"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 -0.240112V226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.126 226.627V-0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.62 113.301V-0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M282.315 84.8608C282.315 100.567 295.029 113.3 310.714 113.3C326.398 113.3 339.113 100.567 339.113 84.8608C339.113 69.1542 326.398 56.4216 310.714 56.4216C295.029 56.4216 282.315 69.1542 282.315 84.8608Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M282.198 84.8887H229.325"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.115 84.863H452.927"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 113.302L367.62 84.863"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 113.302L396.126 84.863"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.418 -0.240112V226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.127 113.302L424.418 84.863"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 70.6412C367.619 78.4945 374.001 84.8608 381.872 84.8608C389.744 84.8608 396.126 78.4945 396.126 70.6412C396.126 62.7879 389.744 56.4216 381.872 56.4216C374.001 56.4216 367.619 62.7879 367.619 70.6412Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.621 70.6423H424.418"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.871 84.8619V-0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 84.8587C452.927 96.3617 446.009 106.73 435.396 111.134C424.784 115.537 412.57 113.103 404.447 104.968C396.324 96.8342 393.897 84.6035 398.291 73.9762C402.688 63.349 413.042 56.4216 424.529 56.4216"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 169.964C452.927 154.936 446.931 140.527 436.261 129.899C425.591 119.271 411.115 113.301 396.023 113.301C380.93 113.301 366.458 119.271 355.784 129.896C345.111 140.52 339.115 154.933 339.115 169.961"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 113.301C452.927 83.1898 440.946 54.3106 419.626 33.0169C398.301 11.7232 369.381 -0.240112 339.223 -0.240112C309.068 -0.240112 280.148 11.7232 258.824 33.0135C237.499 54.3072 225.519 83.1864 225.519 113.301"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M452.927 226.627L396.129 169.964"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.418 198.188L396.127 226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.875 70.6424L452.927 -0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M424.418 91.9729C424.418 95.8995 427.609 99.0826 431.545 99.0826C435.481 99.0826 438.672 95.8995 438.672 91.9729C438.672 88.0462 435.481 84.863 431.545 84.863C427.609 84.863 424.418 88.0462 424.418 91.9729Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M431.543 84.8619V-0.240112"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 77.7522C339.113 81.6788 342.303 84.8619 346.239 84.8619C350.175 84.8619 353.366 81.6788 353.366 77.7522C353.366 73.8255 350.175 70.6423 346.239 70.6423C342.303 70.6423 339.113 73.8255 339.113 77.7522Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.871 113.301V226.627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.129 198.296C396.129 213.943 408.843 226.627 424.528 226.627C440.212 226.627 452.927 213.943 452.927 198.296C452.927 182.649 440.212 169.964 424.528 169.964C408.843 169.964 396.129 182.649 396.129 198.296Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M367.619 184.076C367.619 191.87 374.001 198.188 381.872 198.188C389.744 198.188 396.126 191.87 396.126 184.076C396.126 176.283 389.744 169.964 381.872 169.964C374.001 169.964 367.619 176.283 367.619 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M339.113 184.076C339.113 191.87 345.494 198.188 353.366 198.188C361.238 198.188 367.62 191.87 367.62 184.076C367.62 176.283 361.238 169.964 353.366 169.964C345.494 169.964 339.113 176.283 339.113 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M353.364 184.076C353.364 191.87 359.746 198.188 367.618 198.188C375.49 198.188 381.871 191.87 381.871 184.076C381.871 176.282 375.49 169.964 367.618 169.964C359.746 169.964 353.364 176.282 353.364 184.076Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M381.872 148.635C381.872 152.561 385.063 155.745 388.999 155.745C392.935 155.745 396.126 152.561 396.126 148.635C396.126 144.708 392.935 141.525 388.999 141.525C385.063 141.525 381.872 144.708 381.872 148.635Z"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M396.129 148.635H452.927"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
    <path
      d="M0.5 20C0.5 9.23045 9.23045 0.5 20 0.5H430C440.77 0.5 449.5 9.23045 449.5 20V430C449.5 440.77 440.77 449.5 430 449.5H20C9.23045 449.5 0.5 440.77 0.5 430V20Z"
      stroke="currentColor"
    />
    <defs>
      <clipPath id="clip0_18079_41035">
        <path
          d="M0 20C0 8.9543 8.95431 0 20 0H430C441.046 0 450 8.95431 450 20V430C450 441.046 441.046 450 430 450H20C8.9543 450 0 441.046 0 430V20Z"
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_18079_41035">
        <rect width={450} height={450} fill="white" />
      </clipPath>
      <clipPath id="clip2_18079_41035">
        <rect
          x={-3.13037}
          y={-0.782593}
          width={456.604}
          height={450.92}
          rx={3.19199}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip3_18079_41035">
        <rect
          width={227.355}
          height={228.302}
          fill="white"
          transform="matrix(0 -1 1 0 -3.13037 450.138)"
        />
      </clipPath>
      <clipPath id="clip4_18079_41035">
        <rect
          width={227.355}
          height={228.302}
          fill="white"
          transform="matrix(0 1 1 0 -3.13037 -0.782593)"
        />
      </clipPath>
      <clipPath id="clip5_18079_41035">
        <rect
          width={227.355}
          height={228.302}
          fill="white"
          transform="matrix(0 -1 -1 0 453.474 450.138)"
        />
      </clipPath>
      <clipPath id="clip6_18079_41035">
        <rect
          width={227.355}
          height={228.302}
          fill="white"
          transform="matrix(0 1 -1 0 453.474 -0.782471)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default CoverPlaceholder
